import { groupValidators, applyValidatorToMultipleFields } from '@framework/ui/Organisms/FinalForm/validators/helpers';
import { validateRequiredField } from '@framework/ui/Organisms/FinalForm/validators/validateRequiredField';
import { validateMinLength } from '@framework/ui/Organisms/FinalForm/validators/validateMinLength';
import { validateMaxLength } from '@framework/ui/Organisms/FinalForm/validators/validateMaxLength';
import { validateNumberMaxMinAmount } from '@framework/ui/Organisms/FinalForm/validators/validateNumberMaxMinAmount';
import { IField } from '@framework/ui/Organisms/FinalForm/validators/interfaces/Field';
import { validateAlphanumeric } from '@framework/ui/Organisms/FinalForm/validators/validateAlphanumeric';
import { validateRegExp } from '@framework/ui/Organisms/FinalForm/validators/validateRegExp';
import { ICallDetailsFormValues } from '../interfaces';

export const roadshowIdRegExp = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const validateEntryCode = ({ value, fieldName, fieldCaption }) => groupValidators(
  validateMinLength({ fieldName, fieldCaption, value, length: 3 }),
  validateMaxLength({ fieldName, fieldCaption, value, length: 32 }),
  validateAlphanumeric({ fieldName, fieldCaption, value }),
);

export const validateRoadshowId = ({ value, fieldName, fieldCaption }) => (
  value ? validateRegExp({ fieldName, fieldCaption, value, expression: roadshowIdRegExp }) : null
);

const estimatedDuration: IField = {
  fieldName: 'estimatedDuration',
  fieldCaption: 'EST. Duration',
};

const participantsCount: IField = {
  fieldName: 'approximateNumberOfParticipants',
  fieldCaption: 'Approximate # of participants',
};

const callName: IField = {
  fieldName: 'name',
  fieldCaption: 'Call Name',
};

export const validateCallName = (values, params = callName) => (
  groupValidators(
    validateMinLength({ ...callName, value: values[params.fieldName], length: 3 }),
    validateMaxLength({ ...callName, value: values[params.fieldName], length: 128 }),
    validateRequiredField({ ...callName, value: values.name }),
  )
);

export default (values: ICallDetailsFormValues) => (
  groupValidators(
    validateCallName(values),
    applyValidatorToMultipleFields(
      {
        values,
        validator: validateNumberMaxMinAmount,
        fields: [
          {
            ...participantsCount,
            maxAmount: 1000,
            minAmount: 1,
          },
          {
            ...estimatedDuration,
            maxAmount: 1000,
            minAmount: 1,
          },
        ],
      },
    ),
    applyValidatorToMultipleFields(
      {
        values,
        validator: validateRequiredField,
        fields: [
          { fieldName: 'transactionTypeId', fieldCaption: 'Transaction Type' },
          { fieldName: 'eventTypeId', fieldCaption: 'Event Type' },
          estimatedDuration,
          participantsCount,
        ],
      },
    ),
  )
);
